import React from 'react';
import { Status, Wrapper } from '@googlemaps/react-wrapper';
import type { Library } from '@googlemaps/js-api-loader';
import useSelector from '@redux/typedHooks';

interface Props {
  render?: (status: Status) => React.ReactElement<any, string | React.JSXElementConstructor<any>>;
  children: React.ReactNode;
}

const GOOGLE_MAPS_LIBRARIES: Library[] = ['geometry', 'marker'];

export const GoogleMapsWrapper: React.FC<Props> = ({ render, children }) => {
  const { googleMapsApiKey } = useSelector((state) => state.application);
  return (
    <Wrapper render={render} apiKey={googleMapsApiKey} libraries={GOOGLE_MAPS_LIBRARIES}>
      {children}
    </Wrapper>
  );
};
